// extracted by mini-css-extract-plugin
export default {"container":"large-link-button_container__mIyyQ","link":"large-link-button_link__1bIXI","image":"large-link-button_image__5OKt5"};